/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';
import { useNavigate } from 'react-router-dom';
import { useSMUsersListPageGetContent } from '../machines';
import { TimelineMercury } from '@vlinder-web/timeline-mercury-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { SettingsComp } from '../components/Settings';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { ApplicationStatusPageService } from '../services';
import Loader from '@/components/Loader';
import { USER_LEVEL } from '@/config/userManagement.config';
import { AppNavigatorService } from '@/AppNavigator';

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const getSrv = () => {
  return vappContainer.get<ApplicationStatusPageService>(
    ApplicationStatusPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const srv = getSrv();
  const navigate = useNavigate();
  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});
  const appSrv = getAppSrv();

  const onError = () => {
    //window.location.reload(false);
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onRefresh = () => {
    usersListPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any, status: any) => {
    console.log(`on apply filter`, data,status);
    let criteria: any = [];
    if (data?.applicationId) {
      criteria = [
        {
          column: 'applicationNo',
          op: 'Equal',
          value: data?.applicationId,
        },
      ];
    }
    if (status) {
      criteria = [
        ...criteria,
        {
          column: 'status',
          op: 'Equal',
          value: status,
        },
      ];
    }
    usersListPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const onTogglePress = (key: string, email: string) => {
    if (key === 'view') {
      navigate(`/application-summary/timeline`);
    }
  };
  const [whoAmI, setWhoAmI] = useState('');

  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
  };

  useEffect(() => {
    getWhoamI();
  });

  const _renderPage = () => {
    if (usersListPageState?.matches('RENDER_PAGE')) {
      const settings = USER_LEVEL.owner.includes(whoAmI)
        ? staticPageContentConfig?.settings?.searchStatusFilter
        : staticPageContentConfig?.settings?.searchStatusFilter?.filter(
            (item) => item?.value !== 'APPLICATION_INCOMPLETE'
          ); 
      console.log('hi-set', settings, whoAmI);
      return (
        <>
          {usersListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <>
              {/* <SettingsComp
                {...(settings || {})}
                searchStatusFilter={settings}
                onApplyFilter={onApplyFilter}
                onClearFilter={onClearFilter}
              /> */}
              <UsersListComp
                {...(usersListPageState?.event?.data?.value || {})}
                // onTogglePress={onTogglePress}
                onViewClick={(data: any) => {
                  console.log(`APP SUMMARY ON CLICK : `, data);
                  navigate(
                    `/application-summary/timeline?id=${data?.applicationNo}`,
                    { state: data }
                  );
                }}
                // onRowClick={(id: any) => {
                //   navigate(`/application-summary/timeline?id=${id}`);
                // }}
              />
            </>
          )}
        </>
      );
    }
    if (usersListPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return (
      <>
        {usersListPageState?.event?.data?.value?.isEmpty ? (
          <StateOSD {...(staticPageContentConfig?.loading?.usersEmpty || {})} />
        ) : (
          <UsersListComp
            // {...(usersListPageState?.event?.data?.value || {})}
            {...staticPageContentConfig?.sampleData}
            onTogglePress={onTogglePress}
            onViewClick={props?.onViewClick}
            onRowClick={props?.onViewDetailClick}
          />
        )}
      </>
    );
  };

  const _renderHeader = () => {
    const settings = USER_LEVEL.owner.includes(whoAmI)
    ? staticPageContentConfig?.settings?.searchStatusFilter
    : staticPageContentConfig?.settings?.searchStatusFilter?.filter(
        (item) => item?.value !== 'APPLICATION_INCOMPLETE'
      ); 

    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
               <SettingsComp
                {...(settings || {})}
                searchStatusFilter={settings}
                onApplyFilter={onApplyFilter}
                onClearFilter={onClearFilter}
              />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    usersListPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!usersListPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(usersListPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={usersListPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (usersListPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const renderTimeLine = () => {
    const TIMELINE_ITEMS = [
      {
        key: 'farming',
        headline: 'Farming',
        headlineBackgroundColor: '#579783',
        children: [
          {
            itemId: '1',
            title: 'SHIMMER FRINGE',
            subtitle:
              'Our high rise boot crop jeans are designed with new pockets that smooth, flatter and hold your shape',
            carouselStyles: {
              width: '250px',
              height: '250px',
            },
          },
        ],
      },
    ];
    return (
      <TimelineMercury
        items={TIMELINE_ITEMS}
        onItemClick={(itemId: string) => {}}
      />
    );
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
    </div>
  );
};
